import { ReviewIndexTable } from '@account/services/tables/review-table/review-index.table';
import { Component, OnInit } from '@angular/core';
import { Review } from '@models/performance/review.model';
import { PerformanceMenuService } from '@account/services/menus/performance-menu.service';
import { FeatureFlag } from '@app/enums';
import { FeatureService } from '@app/services/feature.service';

@Component({
    templateUrl: './review-index.template.html',
    styleUrls: ['./review-index.style.scss'],
})
export class ReviewIndexView implements OnInit {
    createPermission = Review.permission.edit;
    isPerformanceImprovementsFeatureFlagEnabled = false;

    constructor(
        public tabMenuService: PerformanceMenuService,
        public table: ReviewIndexTable,
        private featureService: FeatureService
    ) {
        this.table.reload();
    }

    async ngOnInit(): Promise<void> {
        this.isPerformanceImprovementsFeatureFlagEnabled = await this.featureService.has(
            FeatureFlag.performanceReviewImprovements
        );
    }
}
